module.exports = __webpack_public_path__ + "img/linked-cards.d8b1384c.svg";